//TOOLKIt
import { configureStore } from "@reduxjs/toolkit";
//middlewares
import createSagaMiddleware from "redux-saga";
//ROOT-SAGA
import rootSaga from "./rootSaga";
//Reducers 
import documentsReducer from "./Documents/documents.slice.selector";
import notificationReducer from "./NotificationStore/notification.slice.selector";
import userAccountReducer from "./UsersAccount/userAccount.slice.selector";
import rolesReducer from "./Roles/roles.slice.selector";
import interfaceApiReducer from "./InterfaceApi/interfaceApi.slice.selector";
import profileReducer from "./Profile/profile.slice.selector";
import templateReducer from "./Templetes/template.slice.selector"
//////
const sagaMiddleware = createSagaMiddleware();
///Global Main Store
const store = configureStore({
  reducer: {
    TemplateData: templateReducer,
    ProfileData: profileReducer,
    DocumentsData: documentsReducer,
    UsersAccount: userAccountReducer,
    NotificationStore: notificationReducer,
    RolesStore: rolesReducer,
    InterfaceApi: interfaceApiReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, }).concat(sagaMiddleware),
});
sagaMiddleware.run(rootSaga);
export default store;
